<ng-container *ngIf="body" class="section-expander">

  <div class="section-expander-header">
    <div class="triangle" *ngIf="!visible" (click)="visible = true">&#x25B6;</div>
    <div class="triangle" *ngIf="visible" (click)="visible = false">&#x25BC;</div>
    <div class="title">{{header}}</div>
  </div>
  <div *ngIf="visible" class="section-expander-body" [innerHtml]="body">
  </div>

</ng-container>
